import { z } from 'zod/v3';
import { toast } from '@cotera/client/app/components/ui/toaster';
import { err, ok } from 'neverthrow';
import {
  ActionResult,
  ApplicableContext,
  ExecuteContext,
  BaseAction,
} from '../../actions/framework';
import { assertExists } from '@cotera/utilities';
import { DatasetModel } from '../model/dataset.model';
import { EraQL } from '@cotera/era';
import { DATASET_ACTION_GROUP } from './constants';

export class FormatAction extends BaseAction<
  {},
  { t: string; parseError: EraQL.WithRange<EraQL.ParseError> }[]
> {
  title = 'Format EraQL';
  description = 'Formats the EraQL';
  inputSchema = z.object({});
  shortcut = ['ctrl', 'shift', 'l'];
  group = DATASET_ACTION_GROUP;
  icon = 'pencil';

  applicable(context: ApplicableContext): boolean {
    return context.hasTargetedModelOfType(DatasetModel);
  }

  async execute(
    _payload: {},
    context: ExecuteContext
  ): Promise<
    ActionResult<{ t: string; parseError: EraQL.WithRange<EraQL.ParseError> }[]>
  > {
    const dataset = assertExists(context.targetedModelOfType(DatasetModel));

    const originalEraQL = dataset.formState.snapshot().eraql;

    const formattedEraQL = EraQL.formatEraQL(originalEraQL);

    if (formattedEraQL.isOk()) {
      dataset.formState.set({
        ...dataset.formState.snapshot(),
        eraql: formattedEraQL.value,
      });
      return ok({});
    } else {
      toast.error('Unable to format eraQL due to syntax error.');

      const parseErrors = formattedEraQL.error;

      return err(
        parseErrors.map((parseError) => ({
          t: 'formatterError',
          parseError,
        }))
      );
    }
  }
}
